import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { providerTheme } from '@devx/1ux-aura-material-ui-themes';
import { LoggerProvider } from 'resmed-react-mfe-logging';
import LaunchDarklyProvider from './providers/LaunchDarklyProvider';
import './i18n/i18n';
const Entry = () => (_jsx(React.StrictMode, { children: _jsxs(ThemeProvider, { theme: providerTheme, children: [_jsx(CssBaseline, {}), _jsx(LoggerProvider, { children: _jsx(LaunchDarklyProvider, { children: _jsx(Provider, { store: store, children: _jsx(App, {}) }) }) })] }) }));
export default Entry;
